module.exports = __webpack_public_path__ + "img/icon-star-empty.ca8a6021.svg";